import { AnalyticsBrowser } from '@segment/analytics-next';

const analytics = AnalyticsBrowser.load({ writeKey: 'wv1yTS67IdEB0drE6RenoVH0GLFCXcgZ' });

export default analytics;